import { Ajax } from './axios';
// 资讯
export default {
  tradeCreateOrderGET(param = {}) {
    return Ajax.get(`/api/gugongExaminee/v1/trade/create/${param.examId}`);
  },
  getTradeOrderDetailGET(param = {}) {
    return Ajax.get(`/api/gugongExaminee/v1/trade/${param.orderId}`);
  },
  getTradeFreePayGET(param = {}) {
    return Ajax.get(`/api/gugongExaminee/v1/trade/freePay/${param.orderId}`);
  },
};
